import React from 'react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
              alt="Premium hardwood flooring"
              className="rounded-lg shadow-2xl"
            />
            <div className="absolute -bottom-6 -right-6 bg-wood-brown text-white p-6 rounded-lg shadow-xl">
              <div className="text-4xl font-bold">{t('about.experience.years')}</div>
              <div className="text-sm">{t('about.experience.label')}</div>
            </div>
          </div>

          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-wood-dark mb-6">
              {t('about.title')}
            </h2>
            <p className="text-gray-600 mb-6 text-lg leading-relaxed">
              {t('about.paragraph1')}
            </p>
            <p className="text-gray-600 mb-6 text-lg leading-relaxed">
              {t('about.paragraph2')}
            </p>
            <div className="grid grid-cols-2 gap-6 mt-8">
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <div className="text-3xl font-bold text-wood-brown mb-2">{t('about.stats.homes')}</div>
                <div className="text-gray-600">{t('about.stats.homesLabel')}</div>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <div className="text-3xl font-bold text-wood-brown mb-2">{t('about.stats.satisfaction')}</div>
                <div className="text-gray-600">{t('about.stats.satisfactionLabel')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 